import React, { useEffect, useState } from 'react';
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';
import { useDispatch } from 'react-redux';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';

const CustomerContactReport = () => {


    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Customer Contact Report"))
    }, [])
    const [custContact, setCustContact] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [getdataClicked, setGetdataClicked] = useState(false);


    const [clientId, setClientId] = useState([]);
    const [locationId, setLocationId] = useState([]);
    const [accId, setAccId] = useState([]);
    const [romId, setRomId] = useState([]);
    const [apiStatus, setApiStatus] = useState(undefined)

    useEffect(() => {
        fetchCustomerContactReport();
    }, []);


    const fetchCustomerContactReport = async () => {
        setApiStatus(undefined)
        try {

            const response = await GetServiceCaller(`${API_URL}rom-report/6?P_ID=${0}&P_Location_ID=${0}&P_AccID=${0}&P_ROMID=${0}`);
            setApiStatus(response?.status)
            if (response?.status === 200) {
                setCustContact(response.data.header);

                const pid = response.data.clients.map((item) => ({
                    value: item.value,
                    label: item.text
                }))
                pid.unshift({ value: 0, label: "Select..." });
                setClientId(pid);

                const locationid = Object.entries(response.data.locationType).map(([key, value]) => ({
                    value: key,
                    label: value,
                }));
                locationid.unshift({ value: 0, label: "Select..." });
                setLocationId(locationid)


                const accid = response.data.employee.map((item) => ({
                    value: item.value,
                    label: item.text,
                }));
                accid.unshift({ value: 0, label: "Select..." });
                setAccId(accid);

                const romid = response.data.rompoc.map((item) => ({
                    value: item.value,
                    label: item.text
                }))
                romid.unshift({ value: 0, label: "Select..." });
                setRomId(romid);
            }
        } catch (error) {
            console.error("Fetching error", error);

        }
    }


    const columns = {
        ClientName: { text: "Client Name", visible: true },
        Name: { text: "Full Name", visible: true },
        Email: { text: "Email", visible: true },
        Designation: { text: "Designation", visible: true },
        Department: { text: "Department", visible: true },
        Phone: { text: "Phone Number", align: "end", visible: true },
        Remarks: { text: "Remarks", visible: true },
        Location: { text: "Location Type", visible: true },
        Manager: { text: "A/C Manager", visible: true },
        RomPoc: { text: "RMG POC", visible: true }
    };

    const formDatas = [
        {
            name: "Client Name",
            type: "Select",
            options: [...clientId],
        },
        {
            name: "Location Type",
            type: "Select",
            options: [...locationId],
        },
        {
            name: "A/C Manager",
            type: "Select",
            options: [...accId],
        },
        {
            name: "RMG POC",
            type: "Select",
            options: [...romId],
        },
    ];

    const handleGetData = async () => {
        setApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}rom-report/6?P_ID=${filterFormData.find((o) => o.label === "Client Name")
                ? filterFormData.find((o) => o.label === "Client Name").value
                : 0}&P_Location_ID=${filterFormData.find((o) => o.label === "Location Type")
                    ? filterFormData.find((o) => o.label === "Location Type").value
                    : 0}&P_AccID=${filterFormData.find((o) => o.label === "A/C Manager")
                        ? filterFormData.find((o) => o.label === "A/C Manager").value
                        : 0}&P_ROMID=${filterFormData.find((o) => o.label === "RMG POC")
                            ? filterFormData.find((o) => o.label === "RMG POC").value
                            : 0}`);
            setApiStatus(response?.status)
            if (response.status === 200) {
                const cleanedData = response?.data?.header;
                setCustContact(cleanedData);
                // setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Customer Report Tracker. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Customer Report Tracker:", error);
        }
    };

    const [filterFormData, setFilterData] = useState([]);

    const handleChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };


    const handleReset = () => {
        setFilterData([])
        fetchCustomerContactReport()
    }
    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row mt-2">
                        <Dynamic_PR_table
                            data={custContact}
                            columns={columns}
                            itemsPerPage={8}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            showIcon1={true}
                            handleReset={handleReset}
                            showIcon2={false}
                            showIcon3={false}
                            isRequiredStatus={true}
                            isApiStatus={apiStatus}
                            showIcon4={true}
                            showIcon5={false}
                            isSorting={true}
                            formDatas={formDatas}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            isActionRequired={false}
                            isFilterRequired={true}
                            isCheckBoxRequired={false}
                            // handleIcon1={handleEdit}
                            // handleIcon4={handleOpen}
                            handleChange={handleChange}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-person-plus icons"></i>,
                                Icon4Text: "Create Employee",
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerContactReport